import { useMutation, useQueryClient } from 'react-query';

import Api from '../../api/api';

export const deactivatePost = async (reportedPostId: string) => {
  const [response, bodyOrError] = await Api.patch(`posts/${reportedPostId}/deactivate-post`);

  if (!response.ok) {
    throw bodyOrError;
  }

  return bodyOrError;
};

export const useDeactivateReportedPost = () => {
  const queryClient = useQueryClient();
  return useMutation(
    'deactivatePost',
    (data: { reportedPostId: string }) => {
      return deactivatePost(data.reportedPostId);
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['getReportedPostById']);
        queryClient.invalidateQueries('reportedPosts');
      },
    },
  );
};
